module.exports = __webpack_public_path__ + "static/dof-82a1d1324e5d19dcba258beab81ffd9a.png";